module.exports = __webpack_public_path__ + "static/img/hotspotTips.27444072.png";